import { mapboxPnMap } from '@pn/services/map/mapbox';

/**
 * Default implementation of IMap interface.
 */
export const map = mapboxPnMap;
